export default {
    init() {
        setupBlocks();
    }
}

function setupBlocks() {
    let $blocks = $('.block-feature-highlights').not('.initialised');

    if ($blocks.length > 0) {
        $blocks.each((index, item) => {
            let $block = $(item);

            setupBlock($block);

            $block.addClass('initialised');
        });
    }
}

function setupBlock($block) {
    const totalFeatureLine = $block.find('#total-feature-line')[0];
    const featureContainers = $block.find('.feature-line-container');
    const featureDetails = $block.find('.feature-detail');
    const rightColumn = $block.find('.right')[0];
    const leftColumn = $block.find('.left')[0];
    const hr = $block.find('hr')[0];

    if (!totalFeatureLine || featureContainers.length === 0 || !rightColumn || !leftColumn || !hr) return;

    const totalLineHeight = 328;
    let lastScrollY = window.scrollY;
    let isInActiveScrollArea = false;
    let currentActiveIndex = -1;

    const activeClass = 'active';

    const activationDelay = 300;
    const deactivationDelay = 400;
    let activationTimers = Array(featureContainers.length).fill(null);

    function updateFeatureLine() {
        const blockRect = $block[0].getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const currentScrollY = window.scrollY;

        const isScrollingDown = currentScrollY > lastScrollY;
        const isInView = blockRect.top < windowHeight && blockRect.bottom > 0;

        if (isInView && !isInActiveScrollArea) {
            isInActiveScrollArea = true;

            if (featureContainers.length > 0) {
                clearTimeout(activationTimers[0]);
                $(featureContainers[0]).addClass(activeClass);
                currentActiveIndex = 0;
            }
        }

        if (!isInView && isInActiveScrollArea) {
            isInActiveScrollArea = false;
            totalFeatureLine.style.height = '0px';

            featureContainers.each(function(index) {
                clearTimeout(activationTimers[index]);
                $(this).removeClass(activeClass);
            });
            currentActiveIndex = -1;

            lastScrollY = currentScrollY;
            return;
        }

        if (!isInActiveScrollArea) {
            lastScrollY = currentScrollY;
            return;
        }

        let scrollProgress;

        if (isScrollingDown) {
            if (blockRect.top <= windowHeight) {
                const maxScrollDistance = windowHeight + blockRect.height;
                const distanceScrolled = windowHeight - blockRect.top;
                scrollProgress = Math.min(1, distanceScrolled / maxScrollDistance);
            } else {
                scrollProgress = 0;
            }
        } else {
            const maxScrollDistance = windowHeight + blockRect.height;
            const remainingDistance = windowHeight - blockRect.top;
            scrollProgress = Math.max(0, remainingDistance / maxScrollDistance);
        }

        const newHeight = Math.max(0, Math.min(totalLineHeight, scrollProgress * totalLineHeight));
        totalFeatureLine.style.height = `${newHeight}px`;

        const featureCount = featureDetails.length;
        if (featureCount > 0) {
            const progressPerFeature = 1 / featureCount;
            const targetFeatureIndex = Math.min(
                featureCount - 1,
                Math.floor(scrollProgress / progressPerFeature)
            );

            if (targetFeatureIndex !== currentActiveIndex && targetFeatureIndex >= 0) {
                if (currentActiveIndex >= 0) {
                    clearTimeout(activationTimers[currentActiveIndex]);
                    const prevIndex = currentActiveIndex;
                    activationTimers[prevIndex] = setTimeout(() => {
                        $(featureContainers[prevIndex]).removeClass(activeClass);
                    }, deactivationDelay);
                }

                clearTimeout(activationTimers[targetFeatureIndex]);
                activationTimers[targetFeatureIndex] = setTimeout(() => {
                    $(featureContainers[targetFeatureIndex]).addClass(activeClass);
                }, activationDelay);

                currentActiveIndex = targetFeatureIndex;
            }
        }

        lastScrollY = currentScrollY;
    }

    updateFeatureLine();

    window.addEventListener('scroll', updateFeatureLine);
    window.addEventListener('resize', updateFeatureLine);

    function updateLineWidth() {
        if (leftColumn && totalFeatureLine) {
            const leftHeight = $(leftColumn).height();
            const adjustedWidth = leftHeight - 20;

            $(totalFeatureLine).css({
                'max-height': adjustedWidth + 'px'
            });

            if (hr) {
                $(hr).css('width', adjustedWidth);
            }
        }
    }

    updateLineWidth();

    window.addEventListener('resize', updateLineWidth);

    return function cleanup() {
        activationTimers.forEach(timer => clearTimeout(timer));

        window.removeEventListener('scroll', updateFeatureLine);
        window.removeEventListener('resize', updateFeatureLine);
        window.removeEventListener('resize', updateLineWidth);
    };
}
